import { Box, Button, Flex } from "@chakra-ui/react";
import { ErrorBoundary } from "react-error-boundary";
import { AppFullFallbackComponent } from "../components/lib";
// import { AppFullFallbackComponent } from "../components/lib";
import AppSidebar from "./AppSidebar";
import { useToggleSidebarOpen } from "./store/actions/useToggleSidebarOpen";
import { useSelectIsSidebarOpen } from "./store/select/useSelectIsSidebarOpen";
import { LayoutStoreProvider } from "./store/useLayoutStore";

const AppResetBoundary = () => {
  const toggleSidebarOpen = useToggleSidebarOpen();
  const isSidebarOpen = useSelectIsSidebarOpen();

  const handleReset = () => {
    if (!isSidebarOpen) {
      toggleSidebarOpen();
    }
    window.location.reload();
  };

  return <Button onClick={handleReset}>Refresh page</Button>;
};

export const AppLayout = ({ children }) => {
  return (
    <LayoutStoreProvider>
      <Box h="100vh" w="100vw" minW={"5xl"}>
        <Flex h="full" w="full" id="app-container">
          <AppSidebar></AppSidebar>
          {/* Route */}
          <ErrorBoundary
            fallbackRender={({ error }) => (
              <AppFullFallbackComponent
                error={error}
                resetComponent={<AppResetBoundary />}
              />
            )}
          >
            <Box id="app-route" bg="bg.main" flex="1" overflow="hidden">
              {children}
            </Box>
          </ErrorBoundary>
        </Flex>
      </Box>
    </LayoutStoreProvider>
  );
};

export default AppLayout;
